import classNames from './styles.module.scss';

const LEGEND_ITEMS = [
  { color: '#dc2626', key: 'dueTodayOrOverdue' },
  { color: '#fbbf24', key: 'dueWithin3Days' },
  { color: '#14b8a6', key: 'onTrackDays' },
  { color: '#16a34a', key: 'completed' },
  { color: '#cbd5e1', key: 'upcomingOrLocked' },
];

const PipelineLegend = ({ t }) => (
  <div className={classNames.legend}>
    <p className={classNames.legendTitle}>{t('statusKey')}</p>
    {LEGEND_ITEMS.map(({ color, key }) => (
      <span key={key} className={classNames.legendItem}>
        <span className={classNames.dot} style={{ background: color }} />
        {t(key)}
      </span>
    ))}
  </div>
);

export default PipelineLegend;
